// @flow
import { useAuth, useFirestore, useFirestoreDocData } from "reactfire";
import Typography from "@material-ui/core/Typography";
import React from "react";
import dev from "../../common/dev";
import ProfileTickets from "./ProfileTickets";
import PageHeading from "../../components/PageHeading";
import UserDataCard from "../../components/UserDataCard";
import TicketReservationPayButton from "../TicketReservation/TicketReservationPayButton";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";

function ProfileContent() {
  const firestore = useFirestore();
  const auth = useAuth();
  const history = useHistory();
  const user = auth.currentUser;
  const userId = user.uid;
  const usersRef = firestore.collection("users");
  const userDataRef = usersRef.doc(userId);
  const userData = useFirestoreDocData(userDataRef);

  return (
    <>
      <PageHeading>Deine Tickets</PageHeading>
      <ProfileTickets userData={userData} userId={userId} />
      <PageHeading>Persönliche Angaben</PageHeading>
      <UserDataCard user={user} userData={userData} />
      {(dev.isDevMode() || userData.admin) && (
        <Box mt={2}>
          <Typography color="textSecondary" variant="caption">
            User ID: {userId}
          </Typography>
          <Box mt={2}>
            <Button
              onClick={() => history.push(`admin`)}
              variant="contained"
              color="primary"
            >
              Administration
            </Button>&nbsp;&nbsp;
            <TicketReservationPayButton />
          </Box>
        </Box>
      )}
    </>
  );
}

export default ProfileContent;
